import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const excursionModalStyles = makeStyles((theme: Theme) =>
    createStyles({
        modal: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        paper: {
            backgroundColor: "#FFFFFF",
            boxShadow: theme.shadows[5],
            paddingTop: "10px",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "10px",
        },
        icon: {
            cursor: "pointer",
        },
        firstGrid: {
            marginTop: "10px",
            marginBottom: "10px",
        },
        secondGrid: {
            marginTop: "20px",
            marginBottom: "10px",
        },
        thirdGrid: {
            marginTop: "25px",
            marginBottom: "5px",
        },
        button: {
            padding: "8px 16px 8px 16px",
            fontWeight: 200,
        },
        confirm: {
            background: "#00AF41",
            color: "black",
            "&:hover": {
                backgroundColor: "#008C34",
            },
        },
        cancel: {
            border: "1px solid #333333",
            marginRight: "5px",
            "&:hover": {
                backgroundColor: "inherit",
            },
        },
        discard: {
            background: "#DF5031",
            color: "black",
            "&:hover": {
                backgroundColor: "#BE442A",
            },
        },
    })
);
